import { render, staticRenderFns } from "./NotificacionesPage.vue?vue&type=template&id=b1eacd12&scoped=true"
import script from "./NotificacionesPage.vue?vue&type=script&lang=js"
export * from "./NotificacionesPage.vue?vue&type=script&lang=js"
import style0 from "./NotificacionesPage.vue?vue&type=style&index=0&id=b1eacd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1eacd12",
  null
  
)

export default component.exports